import { User } from 'ha/services/apiV2/types/User';
import { MakeCall } from 'ha/services/apiV2/createMakeCall';

const googleLogin = (makeCall: MakeCall) => (code: string) =>
  makeCall<User>('POST', `/api/v2/action/google-onetap-login`, {
    data: { code },
  });

export default googleLogin;
